export const BRAZILIAN_PHONE_DIGITS_LENGTH = 11

export const normalizePhoneDigits = (value: string) => value.replace(/\D/g, "").slice(0, BRAZILIAN_PHONE_DIGITS_LENGTH)

export const formatBrazilianPhone = (value: string) => {
  const digits = normalizePhoneDigits(value)

  if (digits.length <= 2) return digits

  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}

export const isValidBrazilianPhoneWithDdd = (value: string) => {
  const digits = value.replace(/\D/g, "")

  if (digits.length !== BRAZILIAN_PHONE_DIGITS_LENGTH || digits[0] === "0" || new Set(digits).size === 1) {
    return false
  }

  const areaCode = digits.slice(0, 2)

  const subscriber = digits.slice(2)

  return /^[1-9]{2}$/.test(areaCode) && /^[2-9]\d{8}$/.test(subscriber) && new Set(subscriber).size > 1
}
